import * as angular from "angular";
import {IController} from "angular";
import {$agentsFactory} from "../../../agents/$agents.factory";
import {$accountsFactory} from "../../../account/$accounts.factory";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {DepotsAlerts} from "../../services/depots-alerts.service";
import {DepotsDialogService} from "../../services/depots-dialogs-service.service";
import {DepotsRequests} from "../../services/depots-requests.service";
import {DepotsService} from "../../services/depots-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {AccountsService} from "../../../account/services/accounts-service.service";

export class depotsViewCtrl implements IController {

  depot: any;

  private agentsRef: any;
  private accountsRef: any;

  private queryString: any;
  private selectedDepot: any;
  private depotAgentIds: any;
  private depotAccountIds: any;
  private doReload: any;

  /* @ngInject */
  constructor(private depotsDialogService: DepotsDialogService, private $agents: $agentsFactory, private $accounts: $accountsFactory,
              private bringozLoaderService: BringozLoaderService, private depotsAlerts: DepotsAlerts, private $log, private depotsService: DepotsService,
              private confirmDialogService: ConfirmDialogService, private accountsService: AccountsService) {

    this.agentsRef = this.$agents();
    this.accountsRef = this.$accounts();
  }

  $onInit() {
    this.depotAgentIds = [];
    this.depotAccountIds = [];
  }

  onQueryChange(query) {
    this.queryString = query;
  }

  onCreateDepot() {
    this.depotsDialogService.createDepot(event)
      .then((depotToCreate) => {
        return this.depotsService.createOne(depotToCreate);
      })
      .then((createdDepot) => {
        this.doReload = true;
      })

  }

  onReloadDepots() {
    this.doReload = undefined;
  }

  onDepotSelect(selectedDepot) {
    this.selectedDepot = selectedDepot;

    this._getAgents(selectedDepot.id);
    this._getAccounts(selectedDepot.id);
  }

  onDelete(depotId: string) {
    this.confirmDialogService.confirm('Remove Depot', 'Are you sure you want to remove this depot from branch?', event)
      .then(() => {
        this.depotsService.deleteDepot(depotId)
          .then(() => {
          this.doReload = true;
        });
      })
  }

  onCloseNav() {
    this.selectedDepot = undefined;
    this.depotAgentIds = [];
    this.depotAccountIds = [];
  }

  // ******************************
  //        Private methods
  // ******************************

  private _getAgents(depotId) {
    this.depotAgentIds = [];

    this.bringozLoaderService.on();
    this.agentsRef.$getAll({depotIds: [depotId], active: true})
      .then((agentIds) => {
        this.depotAgentIds = agentIds;
      })
      .catch((error) => {
        this.$log.error('Failed to get depot agents @depotsView@onDepotSelect', error);
        this.depotsAlerts.getDriversError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }


  private _getAccounts(depotId) {
    this.depotAccountIds = [];

    this.bringozLoaderService.on();
    // this.accountsRef.$getAll({depotIds: [depotId]})
    //   .then((accountIds) => {
    //     this.depotAccountIds = accountIds;
    //   })
    //   .catch((error) => {
    //     this.depotsAlerts.getAccountsError();
    //     this.$log.error('Failed to get depot accounts @depotsView@onDepotSelect', error);
    //   })
    //   .finally(() => {
    //     this.bringozLoaderService.off();
    //   });
    this.accountsService.getAll({depotIds: [depotId]})
      .then((accounts) => {
        this.depotAccountIds = accounts.map(a => a.id);
      })
      .catch((error) => {
        this.depotsAlerts.getAccountsError();
        this.$log.error('Failed to get depot accounts @depotsView@onDepotSelect', error);
      })
  }


}

angular
  .module('bringoz.admin.depots')
  .component('depotsView', {
    bindings: {},
    template: require('./depots-view.html').default,
    controller: depotsViewCtrl
  });

